import { render, staticRenderFns } from "./PortalGuidelines.vue?vue&type=template&id=ec289716&"
import script from "./PortalGuidelines.vue?vue&type=script&lang=js&"
export * from "./PortalGuidelines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports